<div class="multi-language-property">
  <div class="mlp-header d-flex justify-content-between align-items-center">
    <ix-typography format="display-xs" class="mb-1">{{
      mlp.idShort | translateOrFallback:(mlp.idShort ?? '')
    }}</ix-typography>
    @if (availableLanguages().length > 0) {
      <ix-button
        (click)="addLanguage()"
        icon="add-circle"
        variant="subtle-tertiary"
        onkeydown=""
      >
        {{ 'dpp.generic_submodel_editor.add_language' | translate }}
      </ix-button>
    }
  </div>

  <ix-layout-grid class="pe-0 ps-0">
    @if (usedLanguages.length === 0) {
      <ix-row class="d-flex justify-content-center">
        <ix-col class="text-center" size="12">
          <ix-empty-state
            (actionClick)="addLanguage()"
            action="{{
              'dpp.generic_submodel_editor.add_attribute' | translate
            }}"
            header="{{
              'dpp.generic_submodel_editor.no_attributes' | translate
            }}"
            layout="compact"
            subHeader="{{
              'dpp.generic_submodel_editor.add_attribute' | translate
            }}"
          ></ix-empty-state>
        </ix-col>
      </ix-row>
    }
    <div [formGroup]="formGroup">
      @for (lang of usedLanguages; track lang) {
        <ix-row class="expandable-row">
          <ix-icon-button
            icon="trashcan"
            variant="subtle-primary"
            (click)="removeLanguage(lang)"
            onkeydown=""
          ></ix-icon-button>
          <ix-col class="py-0 ps-3 pe-0 border-left">
            <div class="d-flex flex-column gap-2">
              <div>
                <app-dpp-field-label
                  [label]="
                    'dpp.generic_submodel_editor.mlp_language' | translate
                  "
                ></app-dpp-field-label>
                <ix-select
                  [value]="isPending(lang) ? null : lang"
                  (valueChange)="changeLanguage(lang, $event.detail)"
                  class="w-100"
                >
                  @for (
                    option of getLanguageOptionsForRow(lang);
                    track option.value
                  ) {
                    <ix-select-item
                      [label]="option.label + ' (' + option.value + ')'"
                      [value]="option.value"
                    ></ix-select-item>
                  }
                </ix-select>
              </div>
              <div>
                <app-dpp-field-label
                  [label]="'dpp.generic_submodel_editor.mlp_value' | translate"
                ></app-dpp-field-label>
                <ix-input
                  [formControlName]="lang"
                  class="w-100"
                  [id]="'mlp_' + element.idShort + '_' + lang"
                />
              </div>
            </div>
          </ix-col>
        </ix-row>
      }
    </div>
  </ix-layout-grid>
</div>
